var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui tiny empty circular horizontal label",class:_vm.size,style:(_vm.labelStyle)})}
var staticRenderFns = []

export { render, staticRenderFns }